import { createFileRoute } from '@tanstack/react-router';
import { SecurityPage } from '@/features/account';

export const Route = createFileRoute('/_auth/me/security')({
  component: SecurityPage,
});
